/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-config.js to modify the generation of this file.

const config = {};
config.sitecoreSiteName = 'mmcom';
config.graphQLEndpoint = '/api/mmcom';
config.layoutServiceConfigurationName = 'jss'
config.defaultLanguage = 'en'

module.exports = config;